import React from "react";
import { Minus, Plus, Trash2 } from "lucide-react";
import { formatINR } from "../../lib/utils-cynos";
import VariantSelectors from "../common/VariantSelectors";

const CartItem = ({ item, onQtyChange, onRemove, onVariantChange, compact = false }) => (
  <div className={`flex gap-4 border border-white/10 bg-cynos-card ${compact ? "p-3" : "p-4"}`}>
    <img src={item.image} alt={item.name} className={`${compact ? "w-20 h-24" : "w-24 h-28"} object-cover`} />
    <div className="flex-1 min-w-0">
      <h4 className="font-bold uppercase text-sm leading-tight truncate">{item.name}</h4>
      {(item.sizes?.length > 0 || item.colors?.length > 0) && (
        <VariantSelectors
          sizes={item.sizes}
          colors={item.colors}
          selectedSize={item.size}
          selectedColor={item.color}
          onSizeChange={(nextSize) => onVariantChange(item, nextSize, item.color || "")}
          onColorChange={(nextColor) => onVariantChange(item, item.size, nextColor)}
        />
      )}
      <div className="font-anton text-lg mt-3">{formatINR(item.price)}</div>
      <div className="flex items-center gap-3 mt-2">
        <div className="flex items-center border border-white/20">
          <button onClick={() => onQtyChange(item, item.qty - 1)} className="px-2 py-1 hover:bg-white/10" aria-label="decrease" data-testid={`qty-minus-${item.slug}`}>
            <Minus size={12} />
          </button>
          <span className="px-3 font-mono text-xs">{item.qty}</span>
          <button onClick={() => onQtyChange(item, item.qty + 1)} className="px-2 py-1 hover:bg-white/10" aria-label="increase" data-testid={`qty-plus-${item.slug}`}>
            <Plus size={12} />
          </button>
        </div>
        <button onClick={() => onRemove(item)} className="text-zinc-500 hover:text-cynos-red ml-auto" aria-label="remove">
          <Trash2 size={14} />
        </button>
      </div>
    </div>
  </div>
);

export default CartItem;
